export default __webpack_public_path__ + "static/media/tv-2020-65hz1000-galleryimages-4-200730.9639eda2.jpg";